import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import RoundButton from '../../../Common/RoundButton';
import { useHistory } from 'react-router-dom';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';
import { useEffect } from 'react';
import { logFirebaseEvent } from '../firebase';
import { P2P_HELP_SUCCESSFUL_VIEW } from '../firebase/constant';
import { useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import FaqCongImg from '../../../utils/assests/faq-ticket.png';
const FaqCongratulations = () => {
  const history = useHistory();

  const { ticketResponse,ticketResponseId } = useSelector((state: any) => state.ticket);

  useEffect(() => {
    if (ticketResponseId?.status) {
      document.title = 'stashearn - faq-congratulations';
      logFirebaseEvent(P2P_HELP_SUCCESSFUL_VIEW);
    }
  }, [ticketResponseId]);

  const handleClose = () => {
    history.push('/p2p/dashboard');
  };

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <Box className='circleImage'>
              <img src={FaqCongImg} alt='pending status' />
              <Typography variant='h1'>
                thank you for
                <br /> reaching out to us
              </Typography>
            </Box>

            <Box className='thankYouContent'>
              <Typography>
                you have successfully <br />
                registered a ticket with us. Your ticket
                <br />
                ID is- {ticketResponseId?.results?.ticket_id}
              </Typography>
              <Typography>
                we will get <br /> back to your within 24 hours
              </Typography>
            </Box>
            <div>
              <RoundButton onClick={handleClose} title={'close'} />
            </div>
          </CardContent>
        </Card>
      </BackgroundTheme>
    </>
  );
};

export default FaqCongratulations;
